/* eslint-disable no-undef */
/* eslint-disable react/no-deprecated */
/**
 * Main
 *
 * Handles routing and global imports.
 *
 * @since 1.0.0
 */

// import local dependencies
import $ from 'jquery'; // eslint-disable-line import/no-unresolved
import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';

import components from './components';

import { toKebab } from './util/toKebab';
import Router from './util/Router';
// Routes
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';

const { HTML } = components;

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Example: 'About Us' page, note the change from about-us to aboutUs.
  aboutUs,
  singleProduct,
});

// Load Events
$(document).ready(() => routes.loadEvents());

/**
 * Initialize React stuff
 */
const mount = () => {
  Array.from(document.querySelectorAll('[data-react]')).forEach((el) => {
    const name = el.dataset.react;
    const component = components[name];

    if (!component) return;

    let initialProps = JSON.parse(el.dataset.props || '{}');
    const initialHTML = el.innerHTML;
    const ref = React.createRef();

    if (name === 'Paragraph' || name === 'List' || name === 'Heading') {
      initialProps = { ...initialProps, innerHTML: el.innerHTML };
    }

    ReactDOM.render(
      React.createElement(
        component,
        { ...initialProps, wrapper: ref, root: el },
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#7ab800',
              borderRadius: 0,
            },
          }}
        >
          <HTML className={`${toKebab(name)}__wrapper`} ref={ref}>
            {initialHTML}
          </HTML>
        </ConfigProvider>
      ),
      el
    );
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // Mount the React components when DOMContent loaded.
  mount();
  if (window.acf) {
    // Mount the React components when an ACF block has generated its preview.
    window.acf.addAction('render_block_preview', mount);
    // Mount the React components when an ACF block preview is remounted.
    window.acf.addAction('remount', mount);
  }
});
